import { render, staticRenderFns } from "./Tile.vue?vue&type=template&id=0ccff112&scoped=true"
import script from "./Tile.vue?vue&type=script&lang=ts"
export * from "./Tile.vue?vue&type=script&lang=ts"
import style0 from "./Tile.vue?vue&type=style&index=0&id=0ccff112&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccff112",
  null
  
)

export default component.exports